import PropTypes from 'prop-types';
import { useMemo } from 'react';
import classNames from 'classnames';

import useTranslation from '../hooks/useTranslation';

export type InvalidFeedbackProps = {
  id?: string;
  message: string;
  useI18n?: boolean;
};

export function InvalidFeedback({ id, message, useI18n = true }: InvalidFeedbackProps) {
  const { t } = useTranslation();
  const messageCalculated = useMemo(() => {
    if (message === '#') {
      return '';
    }
    return useI18n ? t(message) : message;
  }, [message, t, useI18n]);
  return (
    <div {...(id && { id })} className={classNames('invalid-feedback', !messageCalculated && 'd-none')}>
      {messageCalculated}
    </div>
  );
}

InvalidFeedback.propTypes = {
  id: PropTypes.string,
  message: PropTypes.string.isRequired,
  useI18n: PropTypes.bool
};

export default InvalidFeedback;
